import { Box, Typography } from "@mui/material";
import { MonthData as MonthDataType } from "../../types/Trader/Trader";
import { useTranslationProvider } from "../../providers/TranslationProvider";
import { useTranslation } from "react-i18next";

const MonthData = ({ data }: { data: MonthDataType }) => {
	const { t } = useTranslation();
	const { language } = useTranslationProvider();
	const labels = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];

	const itaLabels = [
		"Gennaio",
		"Febbraio",
		"Marzo",
		"Aprile",
		"Maggio",
		"Giugno",
		"Luglio",
		"Agosto",
		"Settembre",
		"Ottobre",
		"Novembre",
		"Dicembre",
	];
	const labelToUse = language === "it" ? itaLabels : labels;
	return (
		<Box
			flex="1"
			minWidth="200px"
			maxWidth="400px"
			sx={{
				display: "flex",
				justifyContent: "flex-start",
				alignItems: "flex-start",
				flexDirection: "column",
				padding: "16px",
				borderRadius: "8px",
				backgroundColor: "#222838",
			}}
		>
			<div
				style={{
					background: "#393E4D",
					borderRadius: "200px",
					paddingLeft: "12px",
					paddingRight: "12px",
					paddingTop: "4px",
					paddingBottom: "4px",
					marginBottom: "8px",
				}}
			>
				<Typography variant="body1" fontWeight="bold" fontSize="16px">
					{
						labelToUse[
							(data.monthId.split("_")[1] as unknown as number) -
								1
						]
					}{" "}
					/ {data.monthId.split("_")[0]}
				</Typography>
			</div>

			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					width: "fit-content",
				}}
			>
				<Typography
					variant="body1"
					fontSize="14px"
					sx={{ marginRight: "5px" }}
				>
					{t("trader.elapsed_time")}:
				</Typography>
				<Typography
					variant="body1"
					fontSize="14px"
					fontWeight="bold"
					sx={{ marginRight: "5px" }}
				>
					{Math.floor((data.elapsedTime / 1000 / 60 / 60) * 100000) /
						100000}
				</Typography>
				<Typography variant="body1" fontSize="14px">
					{t("trader.hours")}
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					width: "fit-content",
				}}
			>
				<Typography
					variant="body1"
					fontSize="14px"
					sx={{ marginRight: "5px" }}
				>
					{t("trader.rate")}:
				</Typography>
				<Typography
					variant="body1"
					fontSize="14px"
					fontWeight="bold"
					sx={{ marginRight: "5px" }}
				>
					{data.hourlyRate} €{" "}
				</Typography>
				<Typography variant="body1" fontSize="14px">
					/ {t("trader.hourly")}
				</Typography>
			</Box>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					width: "fit-content",
				}}
			>
				<Typography
					variant="body1"
					fontSize="14px"
					sx={{ marginRight: "5px" }}
				>
					{t("trader.total")}:
				</Typography>
				<Typography
					variant="body1"
					fontSize="14px"
					fontWeight="bold"
					sx={{ marginRight: "5px" }}
				>
					{Math.floor(
						(data.elapsedTime / 1000 / 60 / 60) *
							data.hourlyRate *
							100000
					) / 100000}{" "}
					€{" "}
				</Typography>
			</Box>

			<Typography variant="body1" fontSize="14px">
				{t("trader.followers")}: {data.followers}
			</Typography>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					width: "fit-content",
				}}
			>
				<Typography
					variant="body1"
					fontSize="14px"
					sx={{ marginRight: "5px" }}
				>
					{t("trader.already_paid")}:{" "}
				</Typography>
				<Typography
					variant="body1"
					fontSize="14px"
					fontWeight="bold"
					color={data.paid ? "#2AD4D4" : "#CE2B37"}
				>
					{data.paid ? t("general.yes") : t("general.no")}
				</Typography>
			</Box>
		</Box>
	);
};

export default MonthData;
